import { Tooltip } from '@mui/material';
import { ReactElement, useRef, useState } from 'react';
import useBreakpoints from '../../helpers/useBreakpoints';
import { isEllipsisActive } from './utils';

export interface ITooltipForEllipsisElementProps {
  children: ReactElement;
  /**
   * By default first children node is used.
   *  But if you want to specify another or deeper children text element where ellipsis is active,
   *  you can return proper element in callback
   */
  onGetTextElementWithEllipsis?: (child: HTMLElement | Element | undefined) => HTMLElement | Element | undefined;
  /**
   * By default title is getting via textContent property on that component.
   * If you need another title in tooltip you can specify it.
   */
  title?: string;
}

export function TooltipForEllipsisElement(props: ITooltipForEllipsisElementProps) {
  const childrenRef = useRef<HTMLElement | Element | undefined>(undefined);
  const { downSm } = useBreakpoints();
  const [tooltipTitle, setTooltipTitle] = useState<string>('');

  return (
    <Tooltip
      title={tooltipTitle}
      ref={childrenRef}
      enterTouchDelay={downSm ? 0 : undefined}
      onMouseEnter={() => {
        if (childrenRef && childrenRef.current) {
          const element = props.onGetTextElementWithEllipsis
            ? props.onGetTextElementWithEllipsis(childrenRef.current)
            : childrenRef.current;
          const ellipsisActive = !!element && isEllipsisActive(element);
          setTooltipTitle((ellipsisActive && (props.title || childrenRef.current?.textContent)) || '');
        } else {
          setTooltipTitle('');
        }
      }}
    >
      {props.children}
    </Tooltip>
  );
}
